import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../store/app.states';
import { Observable, of } from 'rxjs';
import { loadSports } from '../store/actions/sport.actions';  
import { loadCompetitions } from '../store/actions/competitions.actions';
import { loadTeams } from '../store/actions/teams.actions';
import { loadUserPredictions } from '../store/actions/prediction.actions';

export const teamsAdminGuard: CanActivateFn = (route, state): Observable<boolean> => {
  const store = inject(Store<AppState>);
  const userId = JSON.parse(localStorage.getItem('user') || '{}').user_id  
  if ( !userId) return of(false);
  store.dispatch(loadSports())
  store.dispatch(loadTeams())
  return of(true);
};
